import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MeetingsService } from '@core/services';
import { Meeting } from 'lingo2-models';

@Component({
  selector: 'app-meeting-title',
  templateUrl: './meeting-title.component.html',
  styleUrls: ['./meeting-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingTitleComponent {
  @Input() public meeting: Meeting;
  @Input() public routerLink: string[] | string = null;

  public constructor(protected meetingsService: MeetingsService) {}

  public get title(): string {
    return this.meetingsService.meetingFullTitle(this.meeting);
  }

  public get isCourseService(): boolean {
    return this.sequenceTotal > 1;
  }

  public get isOngoingService(): boolean {
    return this.meeting?.user_service?.is?.ongoing;
  }

  public get isOneTimeService(): boolean {
    return !this.isOngoingService && !this.isCourseService;
  }

  public get sequenceTotal(): number {
    return this.meeting?.options?.sequence_total || 1;
  }

  public get sequenceNumber(): number {
    return this.meeting?.options?.sequence_number || 1;
  }
}
